module.exports = __webpack_public_path__ + "img/ST.1e8d5edb.svg";